import { useEffect, useState } from "react";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Input } from "antd";
import ButtonGroup from "antd/es/button/button-group";

// import queryString from "querystring";
import channelUserApi from "../../../apis/ChannelUser.api";
import { setChannelUser } from "../../../redux/store/auth/authDuck";
import { toastAlert } from "../../AlertComponent";

const SignupNickname = ({ setStep }) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const cUser = useSelector((state) => state.auth.channelUser);
	// const user = useSelector(state => state.auth.user);
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	// const queryJson = queryString.parse(history.location.search?.replace("?", ""));
	// const channelId = queryJson?.id;
	// const signupType = queryJson?.type;

	const [nickname, setNickname] = useState("");

	useEffect(() => {
		if (cUser?.nickname) {
			setNickname(cUser.nickname);
		} else if (!cUser?.id) {
			alert("잘못된 접근입니다.");
			history.replace(
				`/together/channel/login?id=${reduxChannel?.influencer_id}`
			);
		}
	}, [cUser]);

	const handleNickname = async () => {
		if (nickname?.length) {
			const param = {
				// id: cUser?.id,
				// phone: cUser?.phone,
				...cUser,
				nickname: nickname,
			};
			const res = await channelUserApi.editChannelUser(param);
			if (res.code === 200) {
				dispatch(
					setChannelUser({
						...cUser,
						nickname: nickname,
					})
				);
				setStep(1);
			} else if (res.code === 999) {
				toastAlert("해당 닉네임이 존재합니다. 다시 입력해 주세요.");
			} else {
				toastAlert("오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
			}
		} else {
			toastAlert("닉네임을 입력해주세요");
		}
	};

	return (
		<div className={`home-recommend-horizontal sign-up-div`}>
			<div
				className={`recommend-title`}
				style={{
					marginTop: "3em",
				}}
			>
				<p className={`title`}>
					{reduxChannel?.nickname}와{"\n"}소통 할 닉네임을 입력해주세요!
				</p>
			</div>
			<div className={`signup-body signup-success-font`}>
				<p className={`signup-success-font`}>
					유튜브에서 사용하시는 닉네임을 입력해주시면{"\n"}
					소통하는데 더욱 좋습니다!
				</p>
			</div>

			<div className={`login-div`}>
				<p className={`login-title`}>닉네임</p>
				<Input
					type={"text"}
					placeholder={`닉네임을 입력해주세요`}
					name={"nickname"}
					value={nickname}
					onChange={(e) => setNickname(e.target.value)}
				/>
			</div>

			<div className={`signup-footer`} style={{ padding: 0 }}>
				<ButtonGroup>
					<Button
						className={`black-button`}
						style={{ width: "100%" }}
						onClick={handleNickname}
					>
						다음
					</Button>
				</ButtonGroup>
			</div>
		</div>
	);
};
export default SignupNickname;
